import React from "react";
import { withRouter } from "react-router-dom";
import { Switch, Route } from "react-router";
import CartaNewContainer from "./CartaNewContainer";
import CartasAllContainer from "./CartasAllContainer";
const CartasContainer = () => {
  return (
    <>
      <>
        <Switch>
          <Route exact path="/home/cartas">
            <CartasAllContainer />
          </Route>
          <Route path="/home/cartas/new">
            <CartaNewContainer />
          </Route>
          <Route
            exat
            path="/home/cartas/edit/:carta_id"
            component={CartaNewContainer}
          />
        </Switch>
      </>
    </>
  );
};

export default withRouter(CartasContainer);
